/**
 * Utility function to validate the number of words in an input.
 *
 * @param {string} text - The text to validate.
 * @param {Object} options - Options for validation.
 * @param {number} [options.minLength] - Minimum word length.
 * @param {number} [options.maxLength] - Maximum word length.
 * @return {boolean} - Returns true if the word length is within the specified range, false otherwise.
 */
export const validateWordCount = (
  text: string,
  options: {
    minLength?: number
    maxLength?: number
  },
): boolean => {
  if (typeof text !== 'string') {
    throw new TypeError('Input must be a string')
  }
  if (options.minLength == null && options.maxLength == null) {
    throw new Error('At least one of minLength or maxLength must be specified')
  }

  const wordCount = text
    .trim()
    .split(/\s+/)
    .filter((word) => word.length > 0).length

  if (options.minLength && wordCount < options.minLength) {
    return false
  }
  if (options.maxLength && wordCount > options.maxLength) {
    return false
  }
  return true
}
